module.exports = __webpack_public_path__ + "678d8acbb34032d5aa01399bac056035.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/cities-countries/Rome3.jpg
// module id = 3524
// module chunks = 0